import {isRegionGermany} from "@/core/utils/helpers/regions/currentRegionHelper";

const GERMAN_PHONE_CODE = 49;

/**
 * Check if a given phone number code is valid.
 *
 * @param {string|null} phone - The phone number to be validated.
 * @returns {boolean} - True if the phone number code is valid, false otherwise.
 */
export function phoneNumbersCodeIsValid(phone) {
    if (!phone) {
        return false;
    }

    const dialCode = process.env.MIX_APP_PHONE_DIAL_CODE;

    if (isRegionGermany() && phone.substring(0, 4) === '+491' || phone.substring(0, 2) === '01' || phone.substring(0, 5) === '00491' || phone[0] === '1') {
        return true;
    }

    const phoneStartersWithCode = [
        dialCode,
        "+" + dialCode,
        "00" + dialCode,
    ];

    if (phoneStartsWith(phone, phoneStartersWithCode)) {
        return true;
    }

    if (parseInt(dialCode, 10) !== GERMAN_PHONE_CODE) {
        return false;
    }

    const otherCountryPhoneStarters = ['00', '+'];
    if (phoneStartsWith(phone, otherCountryPhoneStarters)) {
        return false;
    }

    // Local Germany numbers start with '0'
    return phone.startsWith('0');
}

/**
 * Format a phone number for WhatsApp.
 *
 * @param {string|null} phone - The phone number to be validated.
 * @returns {string} - The formatted phone number for WhatsApp.
 */
export function numberForWhatsApp(phone) {
    const dialCode = process.env.MIX_APP_PHONE_DIAL_CODE;

    if (phone) {
        if (phone.startsWith('00')) {
            phone = phone.substring(2);
        }

        if (phone.startsWith('0')) {
            phone = phone.substring(1);
        }

        if (phone.startsWith(dialCode)) {
            return `+${phone}`;
        }

        // If the phone number doesn't start with '+', prepend '+' country dial code
        if (!phone.startsWith('+')) {
            return `+${dialCode}${phone}`;
        }
    }

    // Return the original phone number if it's empty or already in the correct format
    return phone;
}

/**
 * Check if a string starts with any of the specified prefixes.
 *
 * @param {string} str - The string to be checked.
 * @param {string[]} prefixes - An array of prefixes to check against.
 * @returns {boolean} - True if the string starts with any of the prefixes, false otherwise.
 */
function phoneStartsWith(str, prefixes) {
    return prefixes.some(prefix => str.startsWith(prefix));
}
